import { render, staticRenderFns } from "./schemeinfo.vue?vue&type=template&id=add0881e&scoped=true"
import script from "./schemeinfo.vue?vue&type=script&lang=js"
export * from "./schemeinfo.vue?vue&type=script&lang=js"
import style0 from "./schemeinfo.vue?vue&type=style&index=0&id=add0881e&prod&lang=scss&scoped=true"
import style1 from "./schemeinfo.vue?vue&type=style&index=1&id=add0881e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add0881e",
  null
  
)

export default component.exports